export const config = {
  cloudName: "dp05nvlmb",
  uploadPreset: "i05wncxy"
};
